import { render, staticRenderFns } from "./shengShiXian.vue?vue&type=template&id=3050d02e&"
import script from "./shengShiXian.vue?vue&type=script&lang=js&"
export * from "./shengShiXian.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports